@if (showBanner()) {
<div class="network-status-banner text-center" role="status" aria-live="polite">
    <p-message [severity]="severity()" size="small">{{ message() }}</p-message>
</div>
}
